export class RestrictionsModel {
  constructor(data = {}) {
    this.uuid = data.uuid;
    this.deleted = data.deleted;
    this.excludes = false;
  }
}

export class ProductCategoryRestriction extends RestrictionsModel {
  constructor(data = {}) {
    super(data);
    this["@class"] =
      "br.com.stoom.kernel.model.persistence.restriction.ProductCategoryRestriction";
    this.categories = data.categories;
    this.products = data.products;
    this.excludes = false;
  }
}

export class DateRestriction extends RestrictionsModel {
  constructor(data = {}) {
    super(data);
    this["@class"] =
      "br.com.stoom.kernel.model.persistence.restriction.DateRestriction";
    this.minDate = data.minDate ? new Date(data.minDate) : undefined;
    this.maxDate = data.maxDate ? new Date(data.maxDate) : undefined;
    this.excludes = false;
  }
}

export class CustomerRestriction extends RestrictionsModel {
  constructor(data = { emails: [], documents: [] }) {
    super(data);
    this["@class"] =
      "br.com.stoom.kernel.model.persistence.restriction.CustomerRestriction";
    this.emails = data.emails;
    this.documents = data.documents;
    this.excludes = false;
  }
}

export class FirstPurchaseRestriction extends RestrictionsModel {
  constructor(data = {}) {
    super(data);
    this["@class"] =
      "br.com.stoom.kernel.model.persistence.restriction.FirstPurchaseRestriction";
    this.excludes = false;
  }
}

export class PriceRestriction extends RestrictionsModel {
  constructor(data = {}) {
    super(data);
    this["@class"] =
      "br.com.stoom.kernel.model.persistence.restriction.PriceRestriction";
    this.minPrice = data.minPrice;
    this.excludes = false;
    this.maxPrice = data.maxPrice;
  }
}

export class BuyXProductRestriction extends RestrictionsModel {
  constructor(data = {}) {
    super(data);
    this["@class"] =
      "br.com.stoom.kernel.model.persistence.restriction.BuyXProductRestriction";
    this.amount = data.amount;
    this.excludes = false;
  }
}

export class CustomerGroupRestriction extends RestrictionsModel {
  constructor(data = {}) {
    super(data);
    this["@class"] =
      "br.com.stoom.avenida.model.persistence.restriction.AvenidaGroupRestriction";
    this.customerGroups = data.customerGroups || [];
    this.excludes = false;
  }
}

export class ZipCodeRestriction extends RestrictionsModel {
  constructor(data = {}) {
    super(data);
    this["@class"] =
      "br.com.stoom.avenida.model.persistence.restriction.AvenidaZipCodeRestriction";
    this.initialZipCode = data.initialZipCode;
    this.finalZipCode = data.finalZipCode;
    this.excludes = false;
  }
}

export class PointOfSaleRestriction extends RestrictionsModel {
  constructor(data = {}) {
    super(data);
    this["@class"] =
      "br.com.stoom.avenida.model.persistence.restriction.AvenidaPointOfSaleRestriction";
    this.pointsOfSale = data.pointsOfSale;
    this.excludes = false;
  }
}

export class AvenidaDeliveryRestriction extends RestrictionsModel {
  constructor(data = {}) {
    super(data);
    this["@class"] =
      "br.com.stoom.avenida.model.persistence.restriction.AvenidaDeliveryRestriction";
    this.optionTypes = data.optionTypes;
    this.excludes = false;
  }
}
